<template>
	<div>
		<el-pagination style="margin: 0px" background prev-text="上一页" next-text="下一页"
			@current-change="handleCurrentChange" layout="prev, pager, next" :page-size=pageSize :total="total">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		name: "Pagetion",
		props: {
			total: {
				type: Number,
				default: 100
			},
			pageSize: {
				type: Number,
				default: 10
			}
		},
		data() {
			return {}
		},
		methods: {
			handleCurrentChange(index) {
				this.$emit('getpageValue', index)
			}
		}
	}
</script>

<style scoped>

</style>
